const BEARER = 'Bearer ';
export const composeToken = token => token.includes(BEARER) ? token : `${BEARER}${token}`;
export const formatToken = token => token ? composeToken(token) : undefined;
//# sourceMappingURL=prepareToken.js.map